import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * If user is logged, it automatically redirect to app-center evenif the user write the adress
 */
@Injectable({ providedIn: 'root' })
export class LoggedOutGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.isAuthenticated$.pipe(
      map(isLogged => {
        if (isLogged) {
          return this.router.createUrlTree(['/app-center']);
        }
        return true;
      })
    );
  }
}
